import { useDispatch, useSelector } from "react-redux";
import {
  empleadoStartAdd,
  empleadoStartUpdate,
} from "../../../actions/empleado";

import { FormUi } from "../../ui";
import { Card, Form, Space, Tooltip } from "antd";
import { ButtonUi } from "../../ui/ButtonUi";
import {
  DateFormats,
  TipoButtonConstants,
} from "../../../types/typesConstants";
import { EmpleadoForm } from "./EmpleadoForm";
import dayjs from "dayjs";
const initialValues = (data = {}) => ({
  id: data?.id || null,
  persona:
    {
      ...data?.persona,
      fechanacimiento: dayjs(data?.persona.fechanacimiento),
      image: data?.persona?.image || null,
    } || null,
  nombres: data?.persona.nombres || null,
  apepaterno: data?.persona.apepaterno || null,
  apematerno: data?.persona.apematerno || null,
  tipodocumento: data?.persona.tipodocumento || null,
  nrodocumento: data?.persona.nrodocumento || null,
  fechanacimiento: dayjs(data?.fechanacimiento) || null,
  direccion: data?.persona.direccion || null,
  email: data?.persona.email || null,
  telefono: data?.persona.telefono || null,
  LocalesEmpleado: data?.LocalesEmpleado?.map((row) => row.local) || [],
  tieneaccesosistema: data?.tieneaccesosistema || false,
  esarqueadorcaja: data?.esarqueadorcaja || false,
  departamento: data?.persona.departamento || null,
  provincia: data?.persona.provincia || null,
  ubigeodireccion: data?.persona.ubigeodireccion || null,
  state: data?.state || true,
  usuario: data?.usuario || null,
  // image: data?.image || [],
  generarusuario: data?.usuario ? false : true,
});
export const EmpleadoScreen = ({ handleCloseForm }) => {
  const dispatch = useDispatch();
  const { activeEmpleado: activeEmpleadoAuth } = useSelector(
    (state) => state.auth
  );

  const { activeEmpleado } = useSelector((state) => state.empleado);
  const [form] = Form.useForm();
  const handleSubmit = async (values) => {
    values = {
      ...values,
      persona: {
        ...values.persona,
        fechanacimiento: dayjs(values.fechanacimiento).format(
          DateFormats.backend
        ),
      },
      LocalesEmpleado: values?.LocalesEmpleado?.map((row) => ({ local: row })),
      empresa: activeEmpleadoAuth?.empresa?.id,
    };
    if (activeEmpleado) dispatch(empleadoStartUpdate(values));
    else dispatch(empleadoStartAdd(values));
    handleCloseForm();
  };
  return (
    <FormUi
      form={form}
      autoComplete="off"
      key="FormEmpleado"
      layout="vertical"
      handleSubmit={handleSubmit}
      initialValues={initialValues(activeEmpleado)}
    >
      <Card
        title={
          <>
            Empleado
            {activeEmpleado ? (
              <small> Editar</small>
            ) : (
              <small> Registrar</small>
            )}
          </>
        }
        size="small"
        extra={
          <Space wrap>
            <ButtonUi typeUi={TipoButtonConstants.Guardar} htmlType="submit">
              Guardar
            </ButtonUi>
            <Tooltip title="Salir">
              <ButtonUi
                typeUi={TipoButtonConstants.Cancelar}
                onClick={handleCloseForm}
              />
            </Tooltip>
          </Space>
        }
      >
        <EmpleadoForm />
      </Card>
    </FormUi>
  );
};
